module.exports = __webpack_public_path__ + "img/ideasvoice-ensures-trusted-relationships.27c9540f.png";